<div class="loading-container" *ngIf="loading">
  <div class="loading">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</div>
<div class="content-container" *ngIf="!loading">

    <ng-container *ngIf="!isPPI">
  <div class="header-container">
    <div class="header-content">
      <h2 class="headline-highlight" *ngIf="!isBilliant">Auto Pay &amp; Redeem</h2>
      <h2 class="headline-highlight" *ngIf="isBilliant">Auto Pay</h2>
      <div class="mat-toggle">
        <mat-slide-toggle [(ngModel)]="autopayToggle" (change)="onToggleChange($event)">
          {{ toggleText }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>
  <div class="mt-3 success-box" *ngIf="successMessage">
    <app-notification-box [isSuccess2]="true">
      <div>Autopay preferences were saved successfully!</div>
    </app-notification-box>
  </div>
  <div class="box-border">
    <h4>Select Payment Method</h4>
    <p>Please select the payment methods you would like to use with Auto Pay. If you elect to use
      your <span *ngIf="!isBilliant">Rewards and</span> Cash,
      please sort your selections in the order you would like them to be used.
    </p>
<!--For Auto Transfer-->
    <p *ngIf="isAutoTransferOn">It appears that your Auto Transfer is currently enabled.If you'd like to use  <img class="hw-24" src="assets/icons/monetization_on.svg"> <b>My Cash</b> balance
      for auto-pay. Please disable Auto Transfer <a href="/my-wallet/my-cash/auto-transfer">here.</a>
    </p>
    <!-- Drag and drop items -->
<div cdkDropList class="drag-and-drop-items" (cdkDropListDropped)="drop($event)">
            <div *ngFor="let item of autopayOptions" class="item" cdkDrag [cdkDragDisabled]="item.disabled" 
           [ngClass]="{disable_animation : item.disabled}">
        <div class="select-pmt" >
          <div class="left-content">
            <input type="checkbox" (change)="onChange($event, item)" [checked]="item.checked" 
              [ngClass]="{unclickable : (autopayToggle && item.key == 'default') || (isAutoTransferOn && item.key == 'cash')}">
            
            <ng-container *ngIf="item.key === 'rewards'">
              <img src="assets/icons/star_rate.svg">
              <div class="content">
                <span class="title">My Rewards</span>
                <span class="detail">After all reward points have been used, the remaining balance will be charged using the stored default payment method.</span>
              </div>
            </ng-container>
            
            <ng-container *ngIf="item.key === 'cash'">
              <img src="assets/icons/monetization_on.svg">
              <div class="content">
                <span class="title">My Cash</span>
                <span class="detail">After all cash has been used, the remaining balance will be charged using the stored default payment method.</span>
              </div>
            </ng-container>

            <ng-container *ngIf="item.key === 'default'">
  
              <!-- Icons for different card types -->
              <img src="assets/icons/account_balance.png"
                  *ngIf="cardType == 'EC' || cardType == 'ECP'">

              <img src="assets/images/card/chkt_visa.svg"
                  *ngIf="cardType == 'Visa'">

              <img src="assets/images/card/chkt_mastercard.svg"
                  *ngIf="cardType == 'Mastercard'">

              <img src="assets/images/card/chkt_amex.svg"
                  *ngIf="cardType == 'Amex'">

              <img src="assets/icons/creditcard-v2.png"
                  *ngIf="cardType != 'Visa' &&
                          cardType != 'Mastercard' &&
                          cardType != 'Amex' &&
                          cardType != 'EC' &&
                          cardType != 'ECP'">

              <div class="content">
                <span class="title">{{ cardType }}</span>

              <!-- Bank account -->
              <span class="digits" *ngIf="cardType == 'EC' || cardType == 'ECP'">
                Bank •••• {{ lastFourDigits }}
                <span class="default">Default</span>
              </span>

              <!-- Credit cards -->
              <span class="digits" *ngIf="cardType != 'EC' && cardType != 'ECP'">
                •••• {{ lastFourDigits }} •
                <span [ngClass]="{ expired: isExpired || isWarning }">
                  {{ formatExpirationDate(ccExpiration) }}
                </span>
                <span class="default">Default</span>
              </span>
            </div>

          </ng-container>

           </div>

          <div *ngIf="item.key === 'default'" class="change-link-container">
              <a [ngStyle]="walletRole=='viewer' 
                     ? {pointerEvents: 'none', color:'#BFB8AF'} 
                     : {pointerEvents: 'auto'}"
                [routerLink]="['/preferences/manage-payment']"
                [queryParams]="{ from: 'auto-redeem' }"
                class="change-link"
              > Change
              </a>
          </div>
          <img src="assets/images/drag_dots.png" *ngIf="item.key == 'rewards' || item.key == 'cash'">
        </div>
      </div>
    </div>
  </div>
  <!-- confirm update button -->
  <div class="button-container mt-3">
    <button (click)="openAutoRedeemDialog()" 
            *ngIf="!buttonLoading" 
            [disabled]="walletRole=='viewer' || systemError || isExpired || isWarning" 
            class="dw-primary-button icon-right">
      Confirm Updates<mat-icon class="black">keyboard_arrow_right</mat-icon>   
    </button>
    <button class="dw-primary-button icon-right" disabled *ngIf="buttonLoading">Confirm Update<span class="spinner-border"></span></button>
    
  </div>
  <div class="mt-2 error-notification-section" *ngIf="isExpired || isWarning">
    <app-notification-box [isDanger]="true">
      <div *ngIf="isExpired">The default payment method selected has expired. To continue, please update your default
        payment method.</div>
      <div *ngIf="isWarning">The default payment method selected is close to expiring. To continue, please update your
        default payment method.</div>
    </app-notification-box>
  </div>
  <div class="mt-2 error" *ngIf="systemError">Something went wrong! Please try again later.</div>
  <div class="mt-2 error" *ngIf="defaultError">To proceed with setting up Auto Redeem & Pay, please ensure that you
    have set your default payment method under Manage Payment Methods.</div>
  <div class="mt-2 error" *ngIf="is4uError">This account is not eligible for Auto Redeem & Pay through digital wallet.
  </div>
</ng-container>

<ng-container *ngIf="isPPI">
  <div class="header-container">
    <div class="header-content">
      <h2 class="headline-highlight">Auto Redeem</h2>
        <div class="mat-toggle">
        <mat-slide-toggle [(ngModel)]="autopayToggle" (change)="onToggleChange($event)">
          {{ toggleText }}
        </mat-slide-toggle>
</div>


    </div>
  </div>

  <div class="box-border">
    <h4>Select Payment Method</h4>
    <p>
      Please select the payment methods for Auto Redeem. If you choose both Rewards and Cash, arrange them in your preferred payment order. If either balance is insufficient, you'll need to manually cover the remaining amount unless Auto Pay is enabled.
    </p>

    <!-- REUSE DRAG & DROP FOR PPI -->
    <div cdkDropList class="drag-and-drop-items" (cdkDropListDropped)="drop($event)">
      <div *ngIf="autopayOptions?.length > 0; else noOptions">
      <div *ngFor="let item of autopayOptions" class="item" cdkDrag [cdkDragDisabled]="item.disabled" 
           [ngClass]="{disable_animation : item.disabled}">
        <div class="select-pmt" >
          <div class="left-content">
            <input type="checkbox" (change)="onChange($event, item)" [checked]="item.checked"
              [ngClass]="{unclickable : (autopayToggle && item.key == 'default') || (isAutoTransferOn && item.key == 'cash')}">
            <img src="assets/icons/star_rate.svg" *ngIf="item.key == 'rewards'">
            <div class="content" *ngIf="item.key == 'rewards'">
              <span class="title">My Rewards</span>
              <span class="detail">After all reward points have been used, the remaining balance will be charged using
                the stored default payment method.</span>
            </div>
            <img src="assets/icons/monetization_on.svg" *ngIf="item.key == 'cash'">
            <div class="content" *ngIf="item.key == 'cash'">
              <span class="title">My Cash</span>
              <span class="detail">After all cash has been used, the remaining balance will be charged using the stored
                default payment method.</span>
            </div>
            <img src="assets/icons/account_balance.png"
              *ngIf="item.key == 'default' && (cardType == 'EC' || cardType == 'ECP')">
            <img src="assets/images/card/chkt_visa.svg" *ngIf="item.key == 'default' && cardType == 'Visa'">
            <img src="assets/images/card/chkt_mastercard.svg" *ngIf="item.key == 'default' && cardType == 'Mastercard'">
            <img src="assets/images/card/chkt_amex.svg" *ngIf="item.key == 'default' && cardType == 'Amex'">
            <img src="assets/icons/creditcard-v2.png" *ngIf="item.key == 'default' && cardType != 'Amex' &&
            cardType != 'Mastercard' && cardType != 'Visa' && cardType != 'ECP' && cardType != 'EC'">
            <div class="content" *ngIf="item.key == 'default'">
              <span class="title">{{ cardType }}</span>
              <span class="digits" *ngIf="cardType == 'EC' || cardType == 'ECP'">Bank •••• {{ lastFourDigits }}<span class="default">Default</span></span>
              <span class="digits" *ngIf="cardType != 'EC' && cardType != 'ECP'">•••• {{
                lastFourDigits }} • <span [ngClass]="{expired : isExpired || isWarning}">
                  {{formatExpirationDate(ccExpiration)}}
                <span class="default">Default</span>
              </span>
              </span>
              <span class="default" *ngIf="!cardType">Default</span> <!-- Just in case somehow cardType comes in blank...show them something at least -->
            </div>
          </div>
          <!-- <div><a (click)="gotoSetDefaultPayment()" class="change-link" *ngIf="item.key == 'default'">Change</a></div> -->
          <div><a [ngStyle]="walletRole=='viewer'?{pointerEvents: 'none',color:'#BFB8AF'}:{pointerEvents: 'visible'}" [routerLink]="['/preferences/manage-payment']" [queryParams]="{ from: 'auto-redeem' }" class="change-link" *ngIf="item.key == 'default'">Change</a></div>
          


          <img src="assets/images/drag_dots.png" *ngIf="item.key == 'rewards' || item.key == 'cash'">
        </div>
      </div>
      </div>
      
<ng-template #noOptions>
  <p class="error">No payment options available. Please set a default payment method first.</p>
</ng-template>
    </div>

  </div>

  <!-- Confirm update button -->
  <div class="button-container mt-3">
<button (click)="openAutoRedeemDialog()" 
        *ngIf="!buttonLoading" 
        [disabled]="walletRole=='viewer' || systemError || isExpired || isWarning || disableButton" 
        class="dw-primary-button icon-right">
  Confirm Updates <mat-icon class="black">keyboard_arrow_right</mat-icon>   
</button>

<button class="dw-primary-button icon-right" 
        disabled *ngIf="buttonLoading">
  Confirm Update <span class="spinner-border"></span>
</button>
  </div>
</ng-container>

</div>